import React from 'react';

interface FeedNewItemsPillProps {
  count: number;
  onClick: () => void;
  itemNoun?: string;
}

export const FeedNewItemsPill: React.FC<FeedNewItemsPillProps> = ({
  count,
  onClick,
  itemNoun = 'trades',
}) => {
  if (count <= 0) return null;
  const noun = count === 1 ? itemNoun.replace(/s$/, '') : itemNoun;
  return (
    <button
      type="button"
      className="feed-new-items-pill"
      onClick={onClick}
      aria-label={`Load ${count} new ${noun}`}
    >
      {count} new {noun} — click to load
    </button>
  );
};

export default FeedNewItemsPill;
